var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 62,
    viewBox: "0 0 59 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7369 49.0012L29.5821 47.8061L28.4371 49.1195L27.2529 47.7449L28.3143 46.6597L29.5333 47.8186L30.716 46.5483L31.8555 47.9327L30.7369 49.0012Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.404 55.3581L23.4026 56.3195C23.0442 55.9146 22.6816 55.5084 22.3022 55.0826L21.0274 56.4656L19.835 55.1675L21.0107 54.0461L22.0902 55.3261C22.5351 54.7919 22.8713 54.3856 23.2953 53.875L24.404 55.3581Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28049 28.0639L6.16472 29.3481L5.00293 28.1126L6.21633 26.9272L7.39764 28.2573L8.51342 26.9662L9.65709 28.1224C9.31818 28.4716 8.95974 28.8431 8.54132 29.2688L7.28049 28.0639Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8817 52.6299L48.1132 51.6087L46.7715 50.4748L48.0379 49.249L49.2513 50.3621L47.9542 51.4932L49.2973 52.6633L47.9333 53.7332L46.8817 52.6299Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8887 30.5793L47.9961 29.4551L49.0881 30.6029L47.9584 31.7159L46.8887 30.5793Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9449 30.7095L25.9044 31.6918L24.7803 30.5412L25.896 29.6201L26.9449 30.7095Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4721 36.8984C55.7789 37.231 56.1318 37.615 56.4749 37.985L55.3591 39.0661L54.3438 37.8932L55.4721 36.8984Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.744 30.6532L40.6129 31.7481L39.5654 30.6351L40.6687 29.5332L41.744 30.6532Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5283 45.3878L40.6301 44.2065L41.7529 45.3599L40.6078 46.4924L39.5283 45.3878Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7602 46.4223L24.7393 45.3899L25.9024 44.3145L26.8787 45.3691L25.7602 46.4223Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2009 31.7393L32.1855 30.6263L33.2804 29.5049L34.3362 30.5887L33.2009 31.7393Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84455 37.9339L3.64648 39.1026L2.60742 38.0062L3.78038 36.9321L4.84455 37.9339Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9072 23.2187L47.9909 22.082C48.3773 22.4897 48.7371 22.8681 49.0774 23.2243L47.9505 24.3485L46.9072 23.2187Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5777 23.3118L18.4759 24.4068L17.3838 23.252L18.5484 22.2085L19.5777 23.3118Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7158 23.2062L25.8316 22.082L26.9083 23.2285L25.7925 24.3318C25.4871 24.0104 25.1245 23.6333 24.7158 23.2062Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3252 15.9374L33.2429 16.967L32.1982 15.8665L33.2596 14.7534L34.3252 15.9374Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3363 37.9773L33.2206 39.1474L32.1885 37.9871L33.3042 36.8838L34.3363 37.9773Z",
    fill: "#2965FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4805 52.7255L40.6367 51.6611L41.7009 52.7617L40.5739 53.8747C40.2392 53.5213 39.8919 53.154 39.4805 52.7255Z",
    fill: "#2965FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5322 37.9112L40.5713 36.8594L41.6871 38.0197L40.5336 39.0298L39.5322 37.9112Z",
    fill: "#2965FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7158 8.45177L25.8079 7.3916L26.9236 8.51438C26.5917 8.86916 26.2347 9.24899 25.84 9.66777L24.7158 8.45177Z",
    fill: "#2965FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3242 38.0015L18.4707 36.7925L19.5376 38.0127L18.4051 39.0909L17.3242 38.0015Z",
    fill: "#2965FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3241 8.54982L33.2473 9.69069C32.8596 9.2733 32.5026 8.8893 32.1553 8.51782L33.2627 7.40479L34.3241 8.54982Z",
    fill: "#2965FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3768 13.5278L28.2778 14.5782L27.3252 13.3734L28.4187 12.3911L29.3768 13.5278Z",
    fill: "#2965FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.244 19.7417L39.2426 20.7768L38.2077 21.8732L37.1045 20.6767L38.244 19.7417Z",
    fill: "#2965FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0234 37.9685L11.1532 36.8652L12.2089 38.0464L10.9621 38.9772C10.7236 38.7226 10.3651 38.3372 10.0234 37.9685Z",
    fill: "#2965FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 17.2646L22.064 18.3902L20.8171 19.41L19.8408 18.3944L21.0026 17.2646Z",
    fill: "#2965FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.852 17.2886L31.8073 18.339L30.7125 19.3324L29.6943 18.371C30.057 18.0357 30.4335 17.6781 30.852 17.2886Z",
    fill: "#2965FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8453 11.0681L30.8174 12.0545L29.7393 10.9248L30.8467 9.83398L31.8453 11.0681Z",
    fill: "#2965FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0491 35.5568L53.0282 36.6531L51.8789 35.4232L52.9863 34.4229L54.0491 35.5568Z",
    fill: "#2965FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2725 20.7237L28.3101 19.6899L29.4106 20.7487L28.2474 21.9146L27.2725 20.7237Z",
    fill: "#2965FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0908 27.1538L17.0671 28.1416L16.0308 29.2282L14.915 28.0707L16.0908 27.1538Z",
    fill: "#2965FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8271 34.1693L29.583 33.1077C30.0014 32.7028 30.3752 32.3508 30.8145 31.9307C31.1204 32.3341 31.4496 32.7673 31.802 33.2301L30.8271 34.1693Z",
    fill: "#2965FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.127 5.86736L38.1744 4.88232L39.3125 6.09693L38.1535 7.19744L37.127 5.86736Z",
    fill: "#2965FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6582 36.6795L34.5215 35.5386L35.7251 34.4771L36.8507 35.4927L35.6582 36.6795Z",
    fill: "#2965FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8235 34.1477L19.8291 33.1292L20.8709 31.9995L22.0007 33.1877L20.8235 34.1477Z",
    fill: "#2965FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0237 43.9394L36.9805 42.8807L38.2441 41.8887L39.1953 43.0101L38.0237 43.9394Z",
    fill: "#2965FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.915 20.6944L20.9332 19.6787L22.0308 20.7236L20.8314 21.8797L19.915 20.6944Z",
    fill: "#2965FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0498 25.6758L6.11816 24.6504L7.23393 25.794L6.05958 26.7554L5.0498 25.6758Z",
    fill: "#2965FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5986 60.0573C39.8915 59.7457 40.2472 59.3617 40.6321 58.9526L41.706 60.1798L40.6014 61.1272L39.5986 60.0573Z",
    fill: "#2965FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2416 17.2456L39.3197 18.3586L38.1705 19.4717L37.0938 18.3823L38.2416 17.2456Z",
    fill: "#2965FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9064 24.541L22.1212 25.7139L20.8659 26.7574L19.8408 25.7139C20.1811 25.341 20.5437 24.9417 20.9064 24.541Z",
    fill: "#2965FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8275 42.9413L30.7913 43.95L29.6504 42.8231L30.868 41.8687L31.8275 42.9413Z",
    fill: "#2965FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2648 12.3447L39.2411 13.3687L38.1727 14.4317L37.0918 13.3089C37.4042 13.0557 37.8226 12.712 38.2648 12.3447Z",
    fill: "#2965FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8066 20.7394L52.9224 19.6528L54.0703 20.7492L53.0005 21.9053L51.8066 20.7394Z",
    fill: "#2965FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3525 55.1897L50.4376 54.085L51.6399 55.2509L50.3986 56.2749L49.3525 55.1897Z",
    fill: "#2965FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 39.3501L31.8752 40.5313L30.7832 41.5275L29.6367 40.4798L30.8125 39.3501Z",
    fill: "#2965FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9691 58.7887C52.534 58.3824 52.1644 58.0346 51.7432 57.6395L52.9984 56.5459L54.0375 57.652L52.9691 58.7887Z",
    fill: "#2965FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8037 3.60234L20.9041 2.45312L22.091 3.61625L20.8177 4.65138L19.8037 3.60234Z",
    fill: "#2965FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4867 2.49414L24.5816 3.5877L23.4156 4.70074L22.2998 3.65588L23.4867 2.49414Z",
    fill: "#2965FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4788 31.9771L51.6113 33.1137L50.4565 34.1781C50.1441 33.8344 49.7912 33.4435 49.4648 33.0859L50.4788 31.9771Z",
    fill: "#2965FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1007 28.3096L43.0603 29.3197L42.084 28.1051L43.1998 27.0908L44.1007 28.3096Z",
    fill: "#2965FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 28.0655C44.7934 27.7442 45.1686 27.4061 45.5842 27.0332L46.647 28.2005C46.3206 28.5358 45.9497 28.9101 45.608 29.2662L44.4336 28.0655Z",
    fill: "#2965FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.416 28.0578L50.4286 27.063L51.529 28.1649L50.3798 29.2125L49.416 28.0578Z",
    fill: "#2965FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 42.8335L23.4129 41.772L24.445 42.9351L23.4004 43.9424L22.2344 42.8335Z",
    fill: "#2965FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4157 12.2871L24.5022 13.3709C24.0977 13.7647 23.7225 14.1306 23.3627 14.484L22.2344 13.3709L23.4157 12.2871Z",
    fill: "#2965FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5771 35.4969L30.8477 34.4507L31.8519 35.5512L30.7891 36.6642L29.5771 35.4969Z",
    fill: "#2965FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.648 42.8715L50.4485 44.0137L49.3662 42.8284L50.4415 41.835L51.648 42.8715Z",
    fill: "#2965FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8396 44.0237L19.7754 42.9023L20.9525 41.8574L22.0055 42.8995L20.8396 44.0237Z",
    fill: "#2965FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39.3184L17.1004 40.5135L15.9986 41.4999L14.8242 40.4676L16 39.3184Z",
    fill: "#2965FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64979 39.3057L9.78092 40.4424L8.56751 41.5123L7.49219 40.4173L8.64979 39.3057Z",
    fill: "#2965FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8624 36.6274L19.7773 35.506L20.8931 34.4751L22.1037 35.5033L20.8624 36.6274Z",
    fill: "#2965FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4506 48.9016L22.1953 47.8456L23.4031 46.6895L24.5077 47.8581L23.4506 48.9016Z",
    fill: "#2965FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7393 20.7331L57.8341 19.7104L58.9987 20.7943L57.8341 21.8948L56.7393 20.7331Z",
    fill: "#2965FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0436 48.9228L42.0547 47.8362L43.0826 46.7231L44.2472 47.8779L43.0436 48.9228Z",
    fill: "#2965FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6121 47.8735L45.5745 48.9072L44.3945 47.8262L45.6637 46.7451L46.6121 47.8735Z",
    fill: "#2965FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1032 26.7627L37.0098 25.7693L38.279 24.6562C38.5049 24.9526 38.8257 25.3714 39.166 25.8194L38.1032 26.7627Z",
    fill: "#2965FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2566 49.1782L29.4518 50.244L28.3179 51.4307L27.2021 50.237L28.2566 49.1782Z",
    fill: "#2965FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16363 41.4962L0.0576172 40.4527L1.21803 39.3647L2.27801 40.5279L1.16363 41.4962Z",
    fill: "#2965FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7676 52.6926C25.1009 52.3518 25.4649 51.9775 25.8555 51.5796L26.9238 52.7441L25.8513 53.8655L24.7676 52.6926Z",
    fill: "#2965FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8308 4.96436L22.1334 5.9967L20.9033 7.17791L19.7959 6.02174L20.8308 4.96436Z",
    fill: "#2965FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0021 26.7753L41.9561 25.7443L43.0718 24.6577L44.2043 25.8083L43.0021 26.7753Z",
    fill: "#2965FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.665 25.757L45.5743 26.7866L44.4014 25.7195L45.6176 24.6245C45.9244 24.9556 46.2828 25.3424 46.665 25.757Z",
    fill: "#2965FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3789 25.6671L50.4654 24.5986C50.8071 24.9854 51.1628 25.3889 51.5477 25.8285L50.4863 26.8567L49.3789 25.6671Z",
    fill: "#2965FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5368 58.7975L44.3555 57.6344L45.6484 56.6201L46.5563 57.7234C46.2997 57.9919 45.9413 58.3704 45.5368 58.7975Z",
    fill: "#2965FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9108 26.7746L51.7881 25.7242L53.0238 24.5986L54.0238 25.7798L52.9108 26.7746Z",
    fill: "#2965FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0449 28.05L38.1607 27.0107L39.2095 28.2031L38.1732 29.2146L37.0449 28.05Z",
    fill: "#2965FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5184 35.5587L23.4612 36.6481L22.3008 35.4279L23.4723 34.5083L24.5184 35.5587Z",
    fill: "#2965FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M20.827 11.9939L19.7363 10.9574L20.9009 9.78174L21.9637 11.1007L20.827 11.9939Z",
    fill: "#2965FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2399 25.873L1.27475 26.762L0 25.7171C0.430967 25.3192 0.801961 24.977 1.25524 24.5596L2.2399 25.873Z",
    fill: "#2965FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3312 6.12562L23.4246 7.16909L22.2363 5.98788L23.4288 4.9458L24.3312 6.12562Z",
    fill: "#2965FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1435 38.0104L48.0124 39.0553L46.9385 37.8964L48.0738 36.8779L49.1435 38.0104Z",
    fill: "#2965FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0.144531 35.4379L1.238 34.4487L2.2687 35.5117L1.20313 36.5802L0.144531 35.4379Z",
    fill: "#2965FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0428 35.641L16.0512 36.6734L14.9229 35.4212L15.9522 34.3374L17.0428 35.641Z",
    fill: "#2965FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55149 31.647L2.5166 30.6424L3.79835 29.5962L4.77465 30.6577L3.55149 31.647Z",
    fill: "#2965FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3919 9.81885C23.795 10.2265 24.1492 10.5868 24.5453 10.9903L23.4156 12.0644L22.2998 11.0321C22.675 10.6147 23.0404 10.2154 23.3919 9.81885Z",
    fill: "#2965FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4754 3.59661C29.0681 3.96948 28.6804 4.32426 28.2536 4.70965L27.2285 3.59661L28.301 2.46826L29.4754 3.59661Z",
    fill: "#2965FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5918 25.6713L35.6573 24.5986L36.8749 25.7631L35.6197 26.7732L34.5918 25.6713Z",
    fill: "#2965FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6295 58.7052L34.5527 57.5922L35.6532 56.5459L36.7382 57.6061L35.6295 58.7052Z",
    fill: "#2965FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68679 33.1725L8.67004 34.1465L7.53613 33.1113L8.70909 32.0122L9.68679 33.1725Z",
    fill: "#2965FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0208 49.165L44.1896 50.2683L43.0905 51.3981L42.0264 50.228L43.0208 49.165Z",
    fill: "#2965FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8257 57.6479L30.8215 58.7401L29.6221 57.5769L30.8578 56.5752L31.8257 57.6479Z",
    fill: "#2965FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1094 1.08243L33.2251 0L34.3409 1.16452L33.2335 2.30121L32.1094 1.08243Z",
    fill: "#2965FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.793 33.0765L52.9394 31.9009L54.0552 33.1211L52.9115 34.1311C52.5949 33.8292 52.217 33.473 51.793 33.0765Z",
    fill: "#2965FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0446 47.8616L52.9637 48.9746L51.834 47.9006L53.0432 46.7583L54.0446 47.8616Z",
    fill: "#2965FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7852 33.0238L57.8089 31.9956L58.9735 33.174L57.7489 34.1159L56.7852 33.0238Z",
    fill: "#2965FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7861 2.46436L31.9019 3.62887L30.8196 4.70296L29.6592 3.55931C30.0181 3.21055 30.3937 2.84557 30.7861 2.46436Z",
    fill: "#2965FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25.796 36.7198L24.6426 35.5233L25.9313 34.4395L27.015 35.5261L25.796 36.7198Z",
    fill: "#2965FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1619 35.546L48.0099 36.737L46.9053 35.4597L47.9583 34.458L49.1619 35.546Z",
    fill: "#2965FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3825 34.3877L56.5387 35.4562C56.1384 35.8736 55.7647 36.2576 55.3463 36.6903L54.2598 35.4882L55.3825 34.3877Z",
    fill: "#2965FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6011 34.2601C40.2259 33.8524 39.855 33.4462 39.4854 33.051L40.6402 31.938L41.7155 33.1623L40.6011 34.2601Z",
    fill: "#2965FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1167 39.2646L12.1669 40.4667L11.0121 41.5241L9.88379 40.4111L11.1167 39.2646Z",
    fill: "#2965FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5376 40.5438L18.4777 41.6096L17.3535 40.4367L18.5446 39.3779L19.5376 40.5438Z",
    fill: "#2965FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9577 40.5131L25.8293 41.6011L24.6689 40.4491L25.8084 39.311L26.9577 40.5131Z",
    fill: "#2965FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9354 3.68647L25.8768 4.73412L24.6787 3.62108L25.8824 2.43848L26.9354 3.68647Z",
    fill: "#2965FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0697 41.8833L49.2302 42.9073L47.9749 44.1149L46.9902 42.9268L48.0697 41.8833Z",
    fill: "#2965FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7158 5.97248L25.7911 4.93457L26.9488 6.04761L25.8107 7.25386L24.7158 5.97248Z",
    fill: "#2965FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 4.91992L29.4497 6.07053L28.2865 7.18357L27.2656 5.96201L28.334 4.91992Z",
    fill: "#2965FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3062 4.96973L34.3773 6.04381L33.2169 7.25981L32.1611 6.08694L33.3062 4.96973Z",
    fill: "#2965FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2193 9.76123L34.303 10.9424L33.2235 11.9845L32.0645 10.9383C32.4396 10.5501 32.8078 10.1758 33.2193 9.76123Z",
    fill: "#2965FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1858 14.5784L32.0547 13.4041L33.2388 12.2646L34.4243 13.4055L33.1858 14.5784Z",
    fill: "#2965FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M33.271 17.1401L34.3227 18.3617C33.9963 18.6998 33.6183 19.0935 33.2222 19.5067L32.1162 18.3826L33.271 17.1401Z",
    fill: "#2965FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8839 46.6245L26.9174 47.8127L25.8114 48.8089C25.5324 48.5389 25.1517 48.1619 24.7695 47.7849C25.0847 47.4551 25.4585 47.0669 25.8839 46.6245Z",
    fill: "#2965FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96191 20.79L11.0777 19.5894L12.1935 20.74L11.0373 21.9114L9.96191 20.79Z",
    fill: "#2965FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2031 48.9296L32.0566 47.8528L33.2491 46.6006L34.3342 47.7999L33.2031 48.9296Z",
    fill: "#2965FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1524 48.9041L36.9893 47.8537L38.2082 46.6655L39.1845 47.8871C38.9014 48.1681 38.5039 48.5591 38.1524 48.9041Z",
    fill: "#2965FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8525 47.8204L40.6363 48.8527L39.5791 47.7717L40.6489 46.6113L41.8525 47.8204Z",
    fill: "#2965FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4527 21.9185L12.4639 20.8499L13.5796 19.7939L14.6954 20.7901L13.4527 21.9185Z",
    fill: "#2965FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8434 19.6602C26.2619 20.0469 26.6287 20.3948 26.9941 20.7384L25.8086 22.0059L24.7207 20.7676L25.8434 19.6602Z",
    fill: "#2965FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1216 47.9003L48.0309 49.0064L46.8496 47.7765C47.222 47.4092 47.6 47.0391 47.9654 46.6802L49.1216 47.9003Z",
    fill: "#2965FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6782 19.7046L41.7773 20.8023L40.6155 22.0086L39.4746 20.8079L40.6782 19.7046Z",
    fill: "#2965FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5729 47.8256L55.386 48.9567C55.0066 48.5908 54.6119 48.2096 54.2451 47.8534L55.4571 46.6318L56.5729 47.8256Z",
    fill: "#2965FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M56.616 20.7892C56.1795 21.2065 55.8155 21.5683 55.4431 21.9286L54.3008 20.7238L55.3998 19.6455L56.616 20.7892Z",
    fill: "#2965FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25.6854L3.70922 24.5278L4.70086 25.7341L3.62415 26.7275L2.5 25.6854Z",
    fill: "#2965FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5508 50.1722L40.5661 49.208L41.7795 50.3016L40.5675 51.4494L39.5508 50.1722Z",
    fill: "#2965FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7945 26.8318L24.6787 25.6854L25.8307 24.5835C26.1655 24.9828 26.5142 25.396 26.8921 25.844L25.7945 26.8318Z",
    fill: "#2965FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5759 26.7834L39.4434 25.7204L40.6303 24.4683L41.7837 25.7204L40.5759 26.7834Z",
    fill: "#2965FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3967 51.4995L54.2266 50.2668L55.4009 49.126L56.5934 50.2696L55.3967 51.4995Z",
    fill: "#2965FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9472 26.7778L46.8398 25.7177L48.0086 24.4961L49.1035 25.7817L47.9472 26.7778Z",
    fill: "#2965FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1332 27.0371L12.2155 28.1501C11.8333 28.5578 11.4609 28.9571 11.0592 29.3884L9.8584 28.1794L11.1332 27.0371Z",
    fill: "#2965FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6201 28.1367L18.5141 29.3276L17.3369 28.0922L18.4945 27.0181L19.6201 28.1367Z",
    fill: "#2965FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6504 55.1894L25.815 54.0068L26.9642 55.259L25.8345 56.3442L24.6504 55.1894Z",
    fill: "#2965FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3857 55.2392L33.2378 56.387L32.1514 55.1682L33.256 54.0552L34.3857 55.2392Z",
    fill: "#2965FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9164 56.265L46.9053 55.2577L48.0629 54.0181L49.1954 55.2202L47.9164 56.265Z",
    fill: "#2965FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8154 29.3481L24.6787 28.1209L25.8224 27.0928L26.9381 28.2058L25.8154 29.3481Z",
    fill: "#2965FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5309 55.2509L55.4263 56.3639L54.2129 55.1855L55.3384 54.0571L56.5309 55.2509Z",
    fill: "#2965FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6411 29.3808L39.4375 28.1801L40.5812 27.0239L41.8016 28.1439L40.6411 29.3808Z",
    fill: "#2965FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M11.157 31.9434L12.2268 33.0453L11.0943 34.2474L9.94922 33.0661C10.3258 32.7141 10.7233 32.3454 11.157 31.9434Z",
    fill: "#2965FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1187 58.7312L32.0518 57.6418L33.2331 56.5288L34.3879 57.5973L33.1187 58.7312Z",
    fill: "#2965FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7546 34.1661L24.7393 33.1476L25.8773 31.8579C26.2358 32.3003 26.5649 32.7094 26.8648 33.0809C26.5761 33.3647 26.1897 33.7403 25.7546 34.1661Z",
    fill: "#2965FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2461 31.8525L34.3033 33.0407L33.1721 34.1301L32.1094 33.056L33.2461 31.8525Z",
    fill: "#2965FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8662 57.5923C47.233 57.257 47.6222 56.8966 47.968 56.585L49.0448 57.6549L47.9806 58.8305L46.8662 57.5923Z",
    fill: "#2965FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1143 28.1099L33.2077 27.0107L34.283 28.1433L33.1924 29.344C32.8395 28.9405 32.4922 28.544 32.1143 28.1099Z",
    fill: "#2965FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M55.452 56.5698L56.5678 57.6063L55.3544 58.679C55.0754 58.4008 54.71 58.0056 54.293 57.566L55.452 56.5698Z",
    fill: "#2965FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9316 33.0354L48.0558 31.9141L49.2036 33.1064L48.053 34.1401L46.9316 33.0354Z",
    fill: "#2965FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7134 44.29L36.7678 45.3697L35.6521 46.4911L34.627 45.2598C34.9212 44.9982 35.3243 44.6365 35.7134 44.29Z",
    fill: "#2965FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2918 44.2715L39.3337 45.3845L38.1565 46.4127L37.084 45.3998L38.2918 44.2715Z",
    fill: "#2965FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8836 24.6187L58.9994 25.7553L57.8223 26.7863L56.7539 25.7665C57.1584 25.3602 57.5252 24.9873 57.8836 24.6187Z",
    fill: "#2965FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0322 30.602L38.208 29.4736L39.2428 30.7383L38.1271 31.6997L37.0322 30.602Z",
    fill: "#2965FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.912 46.6802L22.1505 47.8377L20.8087 48.8242L19.8408 47.7626L20.912 46.6802Z",
    fill: "#2965FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8004 24.3247L56.7627 23.2952L57.9091 22.1265L58.8743 23.3049L57.8004 24.3247Z",
    fill: "#2965FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64006 36.8521L9.72236 37.9748L8.49919 39.0489L7.56055 37.9651L8.64006 36.8521Z",
    fill: "#2965FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0293 24.3967L41.9023 23.2517L43.1185 22.2026L44.1492 23.2475L43.0293 24.3967Z",
    fill: "#2965FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4694 39.044L12.415 37.9685L13.4736 36.8931L14.6257 38.0061L13.4694 39.044Z",
    fill: "#2965FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0883 36.8765L17.1636 38.034L15.9851 39.0246L14.96 37.9756L16.0883 36.8765Z",
    fill: "#2965FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2721 23.2714L38.254 24.3594L37.0811 23.1559L38.2275 22.1709L39.2721 23.2714Z",
    fill: "#2965FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8462 39.1344L19.7305 37.981L21.0122 36.9375L22.0094 37.9531L20.8462 39.1344Z",
    fill: "#2965FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2617 37.9196L23.4221 36.8149L24.3984 38.0894L23.4458 39.073L22.2617 37.9196Z",
    fill: "#2965FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3674 38.0453L28.2935 39.0972L27.2266 38.0203L28.3214 36.9448L29.3674 38.0453Z",
    fill: "#2965FF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7727 36.8633L31.8592 37.9763L30.7058 39.0699L29.7002 37.9429L30.7727 36.8633Z",
    fill: "#2965FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6809 29.4717L36.7967 30.6251L35.5917 31.7381L34.6475 30.536L35.6809 29.4717Z",
    fill: "#2965FF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8362 23.3172L30.8766 24.3676C30.4708 23.9655 30.1012 23.5982 29.6758 23.1739L30.9003 22.186L31.8362 23.3172Z",
    fill: "#2965FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9695 39.0515L42.0322 37.9747L43.0532 36.9229L44.1912 38.0623L42.9695 39.0515Z",
    fill: "#2965FF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8631 50.2903L35.6818 51.477L34.6943 50.133L35.746 49.2412L36.8631 50.2903Z",
    fill: "#2965FF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 39.127L44.4443 37.9764L45.6689 36.9023L46.6061 38.0154L45.5601 39.127Z",
    fill: "#2965FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3294 24.3901L22.2568 23.2047L23.4591 22.1821L24.4452 23.2506L23.3294 24.3901Z",
    fill: "#2965FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4629 37.9061L50.4392 36.9058L51.534 38.0425L50.3806 39.0873L49.4629 37.9061Z",
    fill: "#2965FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M19.835 23.161L20.8921 22.1787L21.9772 23.2834L20.8336 24.3463L19.835 23.161Z",
    fill: "#2965FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0777 22.1787L17.0805 23.1999L15.9508 24.2879L14.9229 23.147L16.0777 22.1787Z",
    fill: "#2965FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4266 52.8224L28.3108 53.9243L27.2578 52.6721L28.2746 51.6426L29.4266 52.8224Z",
    fill: "#2965FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6865 52.5852L35.6196 51.6113L36.7702 52.8468L35.5317 53.7456L34.6865 52.5852Z",
    fill: "#2965FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2314 52.784L38.2216 53.8094L37.0752 52.7117L38.2677 51.6445L39.2314 52.784Z",
    fill: "#2965FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2054 17.0604L36.9893 15.8555L38.2863 14.8037L39.1553 15.9168L38.2054 17.0604Z",
    fill: "#2965FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1653 52.8306L43.0495 53.9047L42.0635 52.7095L43.1541 51.6299L44.1653 52.8306Z",
    fill: "#2965FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3673 53.8218L49.3213 52.7254L50.4998 51.6875L51.5486 52.763L50.3673 53.8218Z",
    fill: "#2965FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0293 52.7357L52.9846 53.8724L51.8438 52.7593L52.9888 51.5962L54.0293 52.7357Z",
    fill: "#2965FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9212 52.8166L57.8152 53.8781L56.8389 52.7053L57.8738 51.7021L58.9212 52.8166Z",
    fill: "#2965FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8507 29.5034L31.9274 30.6471L30.7614 31.6641C30.4407 31.3371 30.0752 30.9685 29.7266 30.6151L30.8507 29.5034Z",
    fill: "#2965FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6964 14.7593L36.7913 15.8361L35.6392 17.009L34.6309 15.864L35.6964 14.7593Z",
    fill: "#2965FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2971 54.0513L29.5287 55.2005C29.0893 55.5692 28.6918 55.9073 28.2358 56.2829L27.2148 55.1699L28.2971 54.0513Z",
    fill: "#2965FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7422 56.3142L29.5957 55.2011L30.8245 54.0645L31.8384 55.2568L30.7422 56.3142Z",
    fill: "#2965FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3536 29.5312L29.4066 30.5747L28.2699 31.7378L27.249 30.5232C27.5433 30.2603 27.945 29.9055 28.3536 29.5312Z",
    fill: "#2965FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3447 31.6977L22.2861 30.657L23.441 29.5439L24.487 30.6681L23.3447 31.6977Z",
    fill: "#2965FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3428 14.7964L29.3902 15.8399L28.266 16.9974L27.2061 15.8023L28.3428 14.7964Z",
    fill: "#2965FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9763 14.7739L22.092 15.8508L20.8117 16.9527L19.8926 15.8397L20.9763 14.7739Z",
    fill: "#2965FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8935 9.57419L19.835 8.52933C20.1822 8.17176 20.5463 7.79611 20.8894 7.43994L21.9744 8.61002L20.8935 9.57419Z",
    fill: "#2965FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2302 58.6434L27.2148 57.6111L28.2902 56.5718L29.3739 57.618L28.2302 58.6434Z",
    fill: "#2965FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8594 1.06879L20.8984 0.0239258L22.0072 1.08966L20.8496 2.26253L19.8594 1.06879Z",
    fill: "#2965FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2886 33.1304L6.10866 34.1864L5.0166 33.1179L6.17003 32.0049L7.2886 33.1304Z",
    fill: "#2965FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0259 44.0321L41.9395 42.8857L43.1082 41.8687L44.1961 42.8426L43.0259 44.0321Z",
    fill: "#2965FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0261 58.7663L41.9424 57.6199L43.1307 56.5903L44.1907 57.5754L43.0261 58.7663Z",
    fill: "#2965FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15386 31.757L5.00879 30.6857L6.1162 29.5811L7.19431 30.6941L6.15386 31.757Z",
    fill: "#2965FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28236 29.5332C1.60733 29.8643 1.97972 30.2288 2.31445 30.5795L1.13313 31.7022L0.197266 30.5808L1.28236 29.5332Z",
    fill: "#2965FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6103 30.6009L45.5713 31.6958L44.4932 30.6134L45.6089 29.5254L46.6103 30.6009Z",
    fill: "#2965FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 35.4945L50.4842 36.7286L49.4033 35.4291L50.4424 34.4302L51.6641 35.4945Z",
    fill: "#2965FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M58.963 57.6687L57.896 58.74L56.7803 57.5755L57.8249 56.6016L58.963 57.6687Z",
    fill: "#2965FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7136 58.9653L36.8866 60.0979L35.5923 61.1845C35.3482 60.8603 35.019 60.4262 34.6982 60.0032L35.7136 58.9653Z",
    fill: "#2965FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M38.114 61.1795L37.04 60.1916L38.2618 58.9951L39.2381 60.2139L38.114 61.1795Z",
    fill: "#2965FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7681 46.4283L29.7109 45.3806L30.8476 44.2397C31.1419 44.5904 31.478 44.9952 31.8658 45.4585L30.7681 46.4283Z",
    fill: "#2965FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M50.367 61.2095L49.2861 60.1048L50.4953 59.0752L51.5888 60.1882L50.367 61.2095Z",
    fill: "#2965FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8584 60.0375C57.1373 59.7592 57.5153 59.3975 57.8626 59.0566L58.9895 60.1488L57.7789 61.2006L56.8584 60.0375Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern4);
export default __webpack_public_path__ + "static/media/pattern4.4889d42cf48102adf402881dc2ff09e3.svg";
export { ForwardRef as ReactComponent };